(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/bankid/components/bankid-waiting.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/bankid/components/bankid-waiting.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.playerLoginReact.logger;
const Button = svs.ui.ReactButton;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Loader = svs.components.ReactLoader.Loader;
const _svs$playerLoginReact = svs.playerLoginReact.constants,
  bankidProgressStatus = _svs$playerLoginReact.bankidProgressStatus,
  bankIdErrorCodes = _svs$playerLoginReact.bankIdErrorCodes,
  appWaitStatus = _svs$playerLoginReact.appWaitStatus,
  route = _svs$playerLoginReact.route;
const _svs$playerLoginReact2 = svs.playerLoginReact.store.playerloginreactactions,
  bankIdBackendStatus = _svs$playerLoginReact2.bankIdBackendStatus,
  setIsBankidOnThisDeviceDesktop = _svs$playerLoginReact2.setIsBankidOnThisDeviceDesktop;
const useBankIdPollStatus = svs.playerLoginReact.bankid.useBankIdPollStatus;
const Bank = svs.ui.ReactBank;
const _svs$playerLoginReact3 = svs.playerLoginReact.sharedComponents,
  useUrlHelper = _svs$playerLoginReact3.useUrlHelper,
  SelectEidMenu = _svs$playerLoginReact3.SelectEidMenu,
  LoginQrCode = _svs$playerLoginReact3.LoginQrCode,
  AriaCountdownTimer = _svs$playerLoginReact3.AriaCountdownTimer;

const BankIdWaiting = _ref => {
  let _ref$isLogin = _ref.isLogin,
    isLogin = _ref$isLogin === void 0 ? true : _ref$isLogin,
    _ref$bankIdPollWait = _ref.bankIdPollWait,
    bankIdPollWait = _ref$bankIdPollWait === void 0 ? appWaitStatus.WAITING_QRCODE : _ref$bankIdPollWait,
    _ref$preFetchedAst = _ref.preFetchedAst,
    preFetchedAst = _ref$preFetchedAst === void 0 ? null : _ref$preFetchedAst;
  const dispatch = ReactRedux.useDispatch();

  const bankIdAutoStartToken = ReactRedux.useSelector(state => state.playerloginreact.autoStartToken);
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const baseUrl = ReactRedux.useSelector(state => state.playerloginreact.baseUrl);
  const history = useHistory();
  const isQrCode = bankIdPollWait === appWaitStatus.WAITING_QRCODE;
  const _useBankIdPollStatus = useBankIdPollStatus(isQrCode, isLogin, bankIdAutoStartToken || preFetchedAst),
    appUrl = _useBankIdPollStatus.appUrl,
    qrCode = _useBankIdPollStatus.qrCode,
    backendStatus = _useBankIdPollStatus.backendStatus,
    cancelBackendPoll = _useBankIdPollStatus.cancelBackendPoll,
    isLastQrRetry = _useBankIdPollStatus.isLastQrRetry,
    backendError = _useBankIdPollStatus.backendError;
  const _React$useState = React.useState(bankidProgressStatus.BEFORE_POLL),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    waitStatus = _React$useState2[0],
    setWaitStatus = _React$useState2[1];
  const _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    shouldShowScanText = _React$useState4[0],
    setShouldShowScanText = _React$useState4[1];
  const _useUrlHelper = useUrlHelper(),
    navigateToCancelUrl = _useUrlHelper.navigateToCancelUrl;
  const isBankidOnThisDeviceDesktop = ReactRedux.useSelector(state => state.playerloginreact.isBankidOnThisDeviceDesktop);

  React.useEffect(() => {
    dispatch(bankIdBackendStatus(backendStatus));
    setWaitStatus(backendStatus);
  }, [backendStatus]);
  React.useEffect(() => {
    if (appUrl && appUrl.length > 5 && bankIdPollWait === appWaitStatus.WAITING_APP && !preFetchedAst) {
      logger.debug('**** open appurl:', appUrl);
      svs.utils.url.navigate(appUrl);
    }
  }, [appUrl]);
  React.useEffect(() => {
    if (isLastQrRetry) {
      const btn = document.getElementById('retryButton');
      if (btn) {
        btn.focus();
      }
    }
  }, [isLastQrRetry]);
  const onBankIdThisDeviceClick = async () => {
    dispatch(setIsBankidOnThisDeviceDesktop(true));
    await cancelBackendPoll();
    if (isLogin) {
      history.push(route.LOGIN_BANKID_POLL_APP_ROUTE);
    } else {
      history.push(route.REGISTRATE_BANKID_POLL_APP_ROUTE);
    }
  };
  const onRetry = async () => {
    await cancelBackendPoll();
    history.push(isLogin ? route.LOGIN_BANKID_START_ROUTE : route.REGISTRATE_BANKID_START_ROUTE);
  };
  const handleTimerDone = React.useCallback(() => {
    setShouldShowScanText(false);
  }, []);
  const onCancelClick = async () => {
    await cancelBackendPoll();
    if (!isBankidOnThisDeviceDesktop && !isStandardMobile) {
      navigateToCancelUrl();
    } else {
      dispatch(setIsBankidOnThisDeviceDesktop(false));
      if (isStandardMobile) {
        logger.debug("**** Doing hard load of ".concat(isLogin ? 'login' : 'registrate'));
        if (isLogin) {
          svs.utils.url.navigate(baseUrl + route.LOGIN_BANKID_START_ROUTE);
        } else {
          svs.utils.url.navigate(baseUrl + route.REGISTRATE_BANKID_START_ROUTE);
        }
      } else if (isLogin) {
        history.push(route.LOGIN_BANKID_START_ROUTE);
      } else {
        history.push(route.REGISTRATE_BANKID_START_ROUTE);
      }
    }
  };
  const handleLoginOnOtherDevice = () => {
    svs.components.analytics.trackEvent({
      category: 'Users',
      action: 'Login Mobile Fallback',
      opt_label: 'bankid'
    });
    history.push(isLogin ? route.LOGIN_BANKID_POLL_QR_ROUTE : route.REGISTRATE_BANKID_POLL_QR_ROUTE);
  };
  return React.createElement("div", {
    className: "fc-navy"
  }, (waitStatus === bankidProgressStatus.WAITING_APP || waitStatus === bankidProgressStatus.BEFORE_POLL || waitStatus === bankidProgressStatus.ERROR_POLL) &&
  bankIdPollWait === appWaitStatus.WAITING_APP && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-top-4 margin-top-3 margin-bottom-1"
  }, React.createElement("p", null, "F\xF6rs\xF6ker starta BankID-appen")), isStandardMobile && React.createElement("div", null, React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    onClick: handleLoginOnOtherDevice,
    size: 300,
    transparent: true
  }, "Logga in p\xE5 en annan enhet"))), (waitStatus === bankidProgressStatus.BEFORE_POLL || waitStatus === bankidProgressStatus.SHOWING_QRCODE || waitStatus === bankidProgressStatus.ERROR_POLL) &&
  bankIdPollWait === appWaitStatus.WAITING_QRCODE && React.createElement(React.Fragment, null, !isStandardMobile && React.createElement(SelectEidMenu, {
    isLogin: isLogin
  }), React.createElement(LoginQrCode, {
    errorMessage: "Inloggningen tog f\xF6r l\xE5ng tid.",
    isError: backendError === bankIdErrorCodes.CUSTOMER_SCAN_TIMEOUT,
    qrCode: qrCode
  }, React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-bottom-1"
  }, React.createElement(AriaCountdownTimer, {
    onDone: handleTimerDone,
    startTime: 300
  })), !isStandardMobile && isLastQrRetry && React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    id: "retryButton",
    onClick: onRetry,
    tabIndex: 0,
    transparent: true
  }, "F\xF6rl\xE4ng tid")), shouldShowScanText && React.createElement("p", {
    className: "padding-top-1"
  }, "Skanna QR-koden med BankID-appen eller starta BankID p\xE5 den h\xE4r enheten.")), !isStandardMobile && React.createElement("div", {
    className: "margin-top-2 margin-bottom-1"
  }, React.createElement(Button, {
    block: true,
    iconPosition: "left",
    inverted: true,
    onClick: onBankIdThisDeviceClick,
    size: 300
  }, React.createElement(Bank, {
    className: "align-left",
    name: "bankid-neg",
    size: 24
  }), "Starta BankID p\xE5 den h\xE4r enheten"))), (waitStatus === bankidProgressStatus.SHOWING_SPINNER || waitStatus === bankidProgressStatus.NEW_CUSTOMER || waitStatus === bankidProgressStatus.RETAIL_CUSTOMER || waitStatus === bankidProgressStatus.ONLINE_CUSTOMER || waitStatus === bankidProgressStatus.REACTIVATED_CUSTOMER) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login-react-margin-top-1 login-react-margin-am-top-8"
  }, waitStatus === bankidProgressStatus.SHOWING_SPINNER ? 'Väntar på identifiering i app' : 'Loggar in...'), React.createElement("div", {
    className: "padding-xs-v-2 padding-am-top-2 login-react-padding-am-bottom-8 margin-am-bottom-4"
  }, React.createElement(Loader, {
    inverted: true,
    size: 300
  }))), React.createElement("div", null, React.createElement(Button, {
    block: true,
    onClick: onCancelClick,
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.playerLoginReact.bankid.components.BankIdWaiting = BankIdWaiting;

 })(window);